export default {"src":"/my-nerdwallet-next/_next/static/media/qr-code.a4798585.svg","height":1130,"width":1130,"blurWidth":0,"blurHeight":0};